/* src/app/order/components/common/date-picker/date-picker.style.scss */
.small-selection {
  padding-left: 10px;
  padding-right: 10px;
}
.small-selection.first {
  padding-left: 15px;
  padding-right: 10px;
}
.small-selection.last {
  padding-left: 10px;
  padding-right: 15px;
}
.clear-selection {
  margin-top: 15px;
  color: #007d40;
  cursor: pointer;
  width: fit-content;
}
.clear-selection nb-icon,
.clear-selection label {
  cursor: pointer;
}
.clear-selection label {
  font-weight: bold;
  font-size: 13px;
  vertical-align: top;
  margin-left: 10px;
}
/*# sourceMappingURL=date-picker.style.css.map */
